import {Component, Inject, Input} from '@angular/core';
import {NgbPopover} from '@ng-bootstrap/ng-bootstrap';
import {IAppliedFiltersUpdater, IAppliedFiltersUpdaterToken} from '../../applied-filters-updater';
import {
    AdvancedFilterFieldTypesEnum, AdvancedFilterOperatorEnum, AdvanceFilterParamType, IAdvanceFilter, IAdvanceFilterComponent
} from '../advance-filter';

@Component({
    selector: 'app-predicate-filter',
    templateUrl: './predicate-filter.component.html',
    styleUrl: './predicate-filter.component.scss'
})
export class PredicateFilterComponent implements IAdvanceFilterComponent<AdvanceFilterParamType> {
    @Input() item: IAdvanceFilter<AdvanceFilterParamType>;
    @Input() filterValue: string | string[];
    @Input() popover: NgbPopover;
    @Input() operator?: AdvancedFilterOperatorEnum;
    @Input() options


    readonly field_type: AdvancedFilterFieldTypesEnum = AdvancedFilterFieldTypesEnum.condition;


    constructor(@Inject(IAppliedFiltersUpdaterToken) private filterUpdater: IAppliedFiltersUpdater<AdvanceFilterParamType>) {
    }

    update(value: 'and' | 'or'):void{
        this.filterUpdater.update({
            ...this.item,
            condition_type: value
        });
    }

    protected readonly AdvancedFilterOperatorEnum = AdvancedFilterOperatorEnum;
}
